module.exports = __webpack_public_path__ + "img/DeliverDrug.0798b096.svg";